import axios from 'axios'
import {appId, auth, logoutUrl} from "./env";

const request = axios.create({
  baseURL: '/proxy/uni-user-api/hotel-manage-platform-api',
  timeout: 1000,
});

request.interceptors.request.use(config => {
    config.headers['APP-ID'] = appId;
    config.headers['X-AUTH-HEADER'] = auth;
    return config
  }, error => {
    return Promise.reject(error)
  },
)
;

request.interceptors.response.use(
  res => {
    let code = res.data.msgCode;
    if (code === 0) {
      return res.data
    }
    if (code === 304) {
      window.location.href = logoutUrl
    }
    return res
  }, error => {
    return Promise.reject(error)
  },
);

export default request


export const getLoginInfo = function (params) {
  return request.get("/tripMemberAuthUser/getLoginInfo", {params: params});
};

// export const getLoginMenus = function (params) {
//   return request.get("/getLoginMenus", {params: params});
// };

export const getLoginMenus = function (params) {
  return request.post("/privilege/queryByToken", params);
};

export const logout = function (params) {
  return request.get("/tripMemberAuthUser/logout", {params: params});
};

export const getUserTags = function (params) {
  return request.post("privilege/queryDataScopeByToken", params);
};



// WEBPACK FOOTER //
// ./src/assets/js/request.js